import { useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { useMST1010_R01Store } from "src/containers/mes/MST/MST1010_R01/Store_MST1010_R01";

import { AgGridReact } from "ag-grid-react";
import { Content_MST1010_R01 } from "./Content_MST1010_R01";
import { MST1010_R01Dto } from "./Dto_MST1010_R01";
import { Info_MST1010_R01 } from "./Info_MST1010_R01";
import { SearchSection_MST1010_R01 } from "./SearchSection_MST1010_R01";
import { Table_MST1010_R01 } from "./Table_MST1010_R01";

export const Container_MST1010_R01 = () => {
	
	const { 
		MST1010_R01Filter, setMST1010_R01Filter,
		MST1010_R01PastFilter, setMST1010_R01PastFilter,
		allCount,
		initData,
	} = useMST1010_R01Store();

	// leftWidth가 변경될 때 localStorage에 저장

	const RESIZER = {
		code: 'MST1010_R01',
		type: 'width',
		storageKey: 'MST1010_R01-split-width',
		min: 5,
		max: 80,
		default: 57
	} as const;
	const gridRef = useRef<AgGridReact<MST1010_R01Dto>>(null);

	
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handleExcelClick,
		defaultMST1010_R01Row,
		fetchData,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_MST1010_R01({
		gridRef,
		containerRef,
		
	});

	return (
	<div className="content-container">
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_MST1010_R01 />
		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_MST1010_R01 gridRef={gridRef} defaultMST1010_R01Row={defaultMST1010_R01Row()} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				// 드래그 시작 방지
				onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
			/>
			<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<Info_MST1010_R01 />
			</div>
		</div>
		<Message />
	</div>
	)
}